import React from "react";
import { connect } from "react-redux";
import { Badge, Button, Card, Col, Spinner, Table } from "react-bootstrap";
import PropTypes from "prop-types";

import CsLineIcons from "../../cs-line-icons";
import { send as pageInfo } from "../../actions/page";
import { all as getAllNotifications, read as readNotification } from "../../actions/notification";
import "../../layout/notifications/style.css";

const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString();
};

const styleCaption = (style) => {
    switch (style) {
        case "UR":
            return "Urgent";
        case "LO":
            return "Low";
        case "3D":
            return "Activity";
        default:
            return "Notification";
    }
};

class NotificationsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            loading: true
        };
    }

    componentDidMount = async () => {
        await this.props.pageInfo({
            title: "All Notifications",
            breadcrumb: "Notifications",
            description: "Notification history"
        });
        await this.loadData();
    };

    loadData = async () => {
        this.setState({ loading: true });
        const items = await this.props.getAllNotifications();
        this.setState({
            items: Array.isArray(items) ? items : [],
            loading: false
        });
    };

    onRead = async (uuid) => {
        await this.props.readNotification(uuid);
        await this.loadData();
    };

    render() {
        const { items, loading } = this.state;

        return (
            <>
                <Col md="8" className="float-right text-end" />
                <Col xs="12">
                    <Card body className="mb-5 notification-page-card">
                        {loading ? (
                            <div className="notification-page-empty">
                                <Spinner animation="border" />
                            </div>
                        ) : items.length ? (
                            <Table responsive hover className="mb-0 notification-page-table">
                                <thead>
                                    <tr>
                                        <th>Notification</th>
                                        <th style={{ width: "140px" }}>Status</th>
                                        <th style={{ width: "190px" }}>Active</th>
                                        <th style={{ width: "190px" }}>Read</th>
                                        <th className="text-end" style={{ width: "130px" }} />
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item) => {
                                        const unread = !item.readDate;
                                        return (
                                            <tr key={item.uuid}>
                                                <td>
                                                    <div className="notification-page-title">
                                                        <CsLineIcons icon={unread ? "bell" : "form-check"} size="15" />
                                                        <span>{item.title || "Notification"}</span>
                                                    </div>
                                                    <div className="text-muted">{item.description}</div>
                                                </td>
                                                <td>
                                                    <Badge bg={unread ? "primary" : "secondary"}>
                                                        {unread ? "Unread" : "Read"}
                                                    </Badge>
                                                    <div className="small text-muted mt-1">{styleCaption(item.style)}</div>
                                                </td>
                                                <td>{formatDate(item.activeDate)}</td>
                                                <td>{formatDate(item.readDate)}</td>
                                                <td className="text-end">
                                                    {unread ? (
                                                        <Button size="sm" variant="outline-primary" onClick={() => this.onRead(item.uuid)}>
                                                            Mark read
                                                        </Button>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        ) : (
                            <div className="notification-page-empty">
                                No notifications yet.
                            </div>
                        )}
                    </Card>
                </Col>
            </>
        );
    }
}

NotificationsPage.propTypes = {
    getAllNotifications: PropTypes.func.isRequired,
    readNotification: PropTypes.func.isRequired,
    pageInfo: PropTypes.func.isRequired
};

export default connect(null, { getAllNotifications, readNotification, pageInfo })(NotificationsPage);
